import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import {
    listTask,
    getSupportTaskById,
    listSupportSubTasks,
    addRemoveSupportComments,
    supportTaskHistory,
} from './support.service'

const initialState = {
    status: 'loaded',
    initialLoading: true,
    tasks: [],
    isNext: false,
    pageLimit: 10,
    currentPage: 1,
    skipPage: 0,
    taskStatus: 'loaded',
    selectedTask: undefined,
    formModal: false,
    subTasksList: [],
    historyStatus: 'loaded',
    historyTask: [],
    isNextHistory: false,
    pageLimitHistory: 30,
    currentPageHistory: 1,
    skipPageHistory: 0,
}

export const supportTaskList = createAsyncThunk(
    'supportSlice/listTask',
    async (payload) => {
        const response = await listTask(payload)
        return response
    }
)

export const supportTaskById = createAsyncThunk(
    'supportSlice/getSupportTaskById',
    async (payload) => {
        const response = await getSupportTaskById(payload)
        return response
    }
)

export const getSupportSubTaskList = createAsyncThunk(
    'supportSlice/listSupportSubTasks',
    async (payload) => {
        const response = await listSupportSubTasks(payload)
        return response
    }
)

export const updateSupportComment = createAsyncThunk(
    'supportSlice/addRemoveSupportComments',
    async (payload) => {
        const response = await addRemoveSupportComments(payload)
        return response
    }
)

export const supportHistoryTaskGet = createAsyncThunk(
    'supportSlice/supportTaskHistory',
    async (payload) => {
        const response = await supportTaskHistory(payload)
        return response
    }
)

export const supportSlice = createSlice({
    name: 'supportSlice',
    initialState,
    reducers: {
        clearSupportTasks: (state) => {
            state.tasks = []
            state.status = 'loaded'
        },
        changePage: (state, action) => {
            state.currentPage = action.payload.currentPage
            state.skipPage = action.payload.skip
            state.pageLimit = action.payload.pageLimit
        },
        selectTaskUpdate: (state, action) => {
            state.selectedTask = action.payload
        },
        switchFormModal: (state, action) => {
            state.selectedTask = undefined
            state.formModal = action.payload.open || false
        },
        clearHistoryTask: (state) => {
            state.historyStatus = 'loaded'
            state.historyTask = []
            state.isNextHistory = false
        },
        changeHistoryPage: (state, action) => {
            state.currentPageHistory = action.payload.currentPage
            state.skipPageHistory = action.payload.skip
            state.pageLimitHistory = action.payload.pageLimit
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(supportTaskList.pending, (state) => {
                if (state.initialLoading) {
                    state.status = 'loading'
                }
            })
            .addCase(supportTaskList.fulfilled, (state, action) => {
                state.status = 'loaded'
                state.initialLoading = false
                const payloadData = action?.payload?.data

                if (
                    Array.isArray(payloadData) &&
                    payloadData.length > 0 &&
                    payloadData[0]?.list
                ) {
                    // Grouped by status/columns
                    state.tasks = payloadData
                        .sort((a, b) => a.position - b.position)
                        .map((item) => ({
                            _id: item._id,
                            position: item?.position,
                            list: Array.isArray(item?.list)
                                ? item.list.sort(
                                      (a, b) => a.position - b.position
                                  )
                                : [],
                        }))
                } else {
                    // Flat list
                    state.tasks = Array.isArray(payloadData) ? payloadData : []
                }
                state.isNext = action.payload.isNext || false
            })
            .addCase(supportTaskList.rejected, (state) => {
                state.status = 'loaded'
                state.initialLoading = false
                state.tasks = []
            })
            .addCase(supportTaskById.pending, (state) => {
                state.taskStatus = 'loading'
            })
            .addCase(supportTaskById.fulfilled, (state, action) => {
                state.taskStatus = 'loaded'
                if (action.payload.data?.data?.[0]) {
                    state.selectedTask = action.payload.data?.data[0]
                } else if (action.payload.data?.data) {
                    state.selectedTask = action.payload.data?.data
                }
            })
            .addCase(supportTaskById.rejected, (state) => {
                state.taskStatus = 'loaded'
            })
            .addCase(getSupportSubTaskList.fulfilled, (state, action) => {
                state.subTasksList = action.payload.data || []
            })
            .addCase(getSupportSubTaskList.rejected, (state) => {
                state.subTasksList = []
            })
            .addCase(supportHistoryTaskGet.pending, (state) => {
                state.historyStatus = 'loading'
            })
            .addCase(supportHistoryTaskGet.fulfilled, (state, action) => {
                state.historyStatus = 'loaded'
                state.historyTask = action.payload.data.data
                state.isNextHistory = action.payload.isNext
            })
    },
})

export const {
    clearSupportTasks,
    changePage,
    selectTaskUpdate,
    switchFormModal,
    clearHistoryTask,
    changeHistoryPage,
} = supportSlice.actions
export const supportState = (state) => state.supportSlice

export default supportSlice.reducer
